import {
    CommitmentApprovalDto,
    CommitmentDraftDto,
    CommitmentDto,
    EventParticipantDto,
} from '../../coaching-base/general';
import { GoalsCollection } from '../goals-collection.model';

import { approvalAlertInfoViewTransformer } from './approval-alert-info-view.transformer';
import { commitmentDistillReducer } from './commitment-distill.reducer';
import { RootState } from './commitment.state';

export function approvalReducer(
    state: RootState,
    draft: CommitmentDraftDto, // TODO revise. might completely switch to getting the approval object from draft object
    approval: CommitmentApprovalDto,
    commitment: CommitmentDto,
    participants: EventParticipantDto[],
    goalMetricIdList: number[],
    goalsCollection: GoalsCollection,
): RootState {
    let nextApprovalInfo = approvalAlertInfoViewTransformer(
        draft ? draft.approval || draft.previousApproval : approval,
        commitment,
        participants,
        state.coachingEvent.deliveryTypes,
        state.metrics,
    );

    nextApprovalInfo = !state.mirrorCopyAlertInfo ? nextApprovalInfo : null;
    let nextState: RootState = {
        ...state,

        // TODO revise
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        draftId: approval && approval.approved != null ? null : state.draftId,

        draft,
        approval,
        approvalAlertInfo: nextApprovalInfo,
        goalsCollection,
    };

    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (approval && approval.commitment) {
        nextState = commitmentDistillReducer(
            nextState,
            approval,
            approval.commitment,
            goalMetricIdList,
            goalsCollection,
        );
    }

    return nextState;
}
